import { ScoreTopic } from '@/types'
import { Tag } from '@/components'
import { getTopicBackground } from '@/utils'
import { hexToCSSFilter } from 'hex-to-css-filter'

type TopicTagProps = {
  topic?: ScoreTopic
  size?: 'tiny' | 'normal'
}

export const TopicTag = (props: TopicTagProps) => {
  const { topic, size = 'tiny' } = props

  return (
    <Tag
      debugName={'pulseQuestion:tag'}
      text={topic?.label}
      variants={[size]}
      styles={{
        wrapper: {
          backgroundColor: getTopicBackground(topic?.color),
        },
        text: {
          color: topic?.color,
        },
        leftIcon: {
          filter: topic?.color
            ? hexToCSSFilter(topic?.color).filter
            : 'initial',
        },
      }}
      leftIconProps={{
        source: topic?.icon,
      }}
    />
  )
}
